function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var GameTemplate = require('../../lib/templates/gametemplate');
var WordblocksGameRulesTemplate = require('./lib/wordblocks-game-rules.template');
var WordblocksGameOptionsTemplate = require('./lib/wordblocks-game-options.template');
var htmlTemplate = require('./lib/game-html.template');
var Wordblocks = /*#__PURE__*/function (_GameTemplate) {
  function Wordblocks(app) {
    var _this;
    _classCallCheck(this, Wordblocks);
    _this = _callSuper(this, Wordblocks, [app]);
    _this.wordlist = [];
    _this.score = '';
    _this.app = app;
    _this.icon = 'fa-solid fa-braille';
    _this.name = 'Wordblocks';
    _this.slug = 'wordblocks';
    _this.description = "A crossword puzzle game with customizable dictionary (language) options. Players take turns moving tiles from their rack to the board to spell out words. ";
    _this.categories = 'Games Boardgame Classic';
    _this.status = 'prod';
    _this["class"] = 'app';
    //
    // Game Class VARS
    //
    _this.minPlayers = 2;
    _this.maxPlayers = 4;
    _this.boardWidth = 1000;
    _this.tileHeight = 163;
    _this.tileWidth = 148;
    _this.letters = {};
    _this.grace_window = 10;
    _this.insert_rankings = true;

    /*this.clock.useShotClock = true;*/

    //All Wordblocks games will be async enabled
    _this.async_dealing = 1;
    _this.can_play_async = 1;
    _this.tilesToHighlight = [];
    _this.moves = [];
    _this.firstmove = 1;
    _this.last_played_word = [];
    _this.loadingDictionary = null; //a flag that we are loading the dictionary in the background

    _this.defaultMsg = "Click on the board to enter a word from that square, click a tile to select it for play, or <span class=\"link tosstiles\" title=\"Double click tiles to select them for deletion\">discard tiles</span> if you cannot move.";
    _this.clock.container = '#clock_';
    return _possibleConstructorReturn(_this, _this);
  }
  _inherits(Wordblocks, _GameTemplate);
  return _createClass(Wordblocks, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var compact_html, i, score, newhtml, wordblocks_self, _i;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (this.browser_active) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              if (!this.initialize_game_run) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              _context.n = 3;
              return this.injectGameHTML(htmlTemplate());
            case 3:
              _context.n = 4;
              return _superPropGet(Wordblocks, "render", this, 3)([app]);
            case 4:
              this.menu.addMenuOption('game-game', 'Game');
              this.menu.addSubMenuOption('game-game', {
                text: 'How to Play',
                id: 'game-intro',
                "class": 'game-intro',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  game_mod.overlay.showClosable(game_mod.returnGameRulesHTML());
                }
              });
              this.menu.addSubMenuOption('game-game', {
                text: 'Stats',
                id: 'game-stats',
                "class": 'game-stats',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  game_mod.overlay.showClosable(game_mod.returnStatsOverlay());
                }
              });
              this.menu.addChatMenu();
              this.menu.render();
              this.hud.auto_sizing = 0; //turn off default sizing
              this.hud.draggable_whole = false;
              this.hud.render();
              this.log.render();

              //Remove hide-scrollbar class from hud
              $('#hud').removeClass('hide-scrollbar');
              try {
                this.playerbox.render();
                compact_html = '';
                for (i = 1; i <= this.game.players.length; i++) {
                  score = this.getPlayerScore(i);
                  newhtml = "<div class=\"playerscore\" id=\"score_".concat(i, "\">").concat(score, "</div>");
                  if (this.useClock) {
                    newhtml += "<div class=\"player_clock\" id=\"clock_".concat(i, "\"></div>");
                  }
                  this.playerbox.updateBody(newhtml, i);
                  compact_html += "<div class=\"score\" id=\"mobile_score_".concat(i, "\"><img class=\"player-identicon\" src=\"").concat(this.app.keychain.returnIdenticon(this.game.players[i - 1]), "\"/><span>: ").concat(score, "</span></div>");
                }
                this.scoreboard.update(compact_html);
                $('#game-scoreboard').off();
                $('#game-scoreboard').on('click', function () {
                  $('.game-playerbox-manager').toggleClass('visible');
                });
                wordblocks_self = this;
                $('.playerscore').on('click', function () {
                  wordblocks_self.overlay.showClosable(wordblocks_self.returnStatsOverlay());
                });
              } catch (err) {
                console.error(err);
              }
              if (this.useClock == 1) {
                this.clock.render();
                for (_i = 0; _i < this.game.clock.length; _i++) {
                  this.clock.displayTime(this.game.clock[_i].limit - this.game.clock[_i].spent, _i + 1);
                }
              }
              try {
                if (app.browser.isMobileBrowser(navigator.userAgent) || window.innerWidth < 600 || window.innerHeight < 600) {
                  this.hammer.render('#gameboard', 600);
                } else {
                  this.sizer.render();
                  this.sizer.attachEvents('.gameboard');
                }
              } catch (err) {
                console.error(err);
              }
            case 5:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render(_x) {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "returnGameRulesHTML",
    value: function returnGameRulesHTML() {
      return WordblocksGameRulesTemplate(this.app, this);
    }
  }, {
    key: "returnMath",
    value: function returnMath(play) {
      var sum = 0;
      var html = "<div class=\"score-overlay\"><table>\n              <thead><tr><td>Word</td><td>Calculation</td><td>Points</td></tr></thead><tbody>";
      var _iterator = _createForOfIteratorHelper(play),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var word = _step.value;
          html += "<tr><td>".concat(word.word, "</td><td>").concat(word.math, "</td><td>").concat(word.score, "</td></tr>");
          sum += word.score;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      html += "</tbody><tfoot><tr><td colspan=\"3\"><hr></td></tr><tr><td>Total:</td><td></td><td>".concat(sum, "</td></tr></tfoot></table></div>");
      return html;
    }
  }, {
    key: "returnStatsOverlay",
    value: function returnStatsOverlay() {
      var html = "<div class=\"stats-overlay\"><table cellspacing=\"10px\" rowspacing=\"10px\"><tr><th>Round</th>";
      for (var i = 0; i < this.game.opponents.length + 1; i++) {
        html += "<th colspan=\"2\">".concat(this.game.playerNames[i], "</th>");
      }
      var totals = new Array(this.game.opponents.length + 1); //Each players total...
      totals.fill(0);
      //console.log(this.game.opponents);
      for (var z = 0; z < this.game.words_played[0].length; z++) {
        html += "</tr><tr><td class=\"center_align\">".concat(z + 1, "</td>");
        for (var _i2 = 0; _i2 < this.game.opponents.length + 1; _i2++) {
          //totals.push(0); //Initialize
          //let words_scored_html = '<table>';
          if (this.game.words_played[_i2][z] != undefined) {
            html += '<td>' + this.game.words_played[_i2][z].word + '</td><td class="right_align">' + this.game.words_played[_i2][z].score + '</td>';
            totals[_i2] += this.game.words_played[_i2][z].score;
          }
        }
        //words_scored_html += '</table>';
        //html += `<td>${words_scored_html}</td>`;
      }
      //console.log(totals);
      html += '</tr><tr><td colspan="10"><hr></td></tr><tfoot><tr><td>Totals</td>';
      for (var _i3 = 0, _totals = totals; _i3 < _totals.length; _i3++) {
        var total = _totals[_i3];
        html += "<td colspan=\"2\" class=\"right_align\">".concat(total, "</td>");
      }
      html += '</tr></tfoot></table></div>';
      return html;
    }
  }, {
    key: "respondTo",
    value: function respondTo(type) {
      var _obj$tx;
      var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      switch (type) {
        case 'ntfy-notification':
          if (((_obj$tx = obj.tx) === null || _obj$tx === void 0 || (_obj$tx = _obj$tx.msg) === null || _obj$tx === void 0 ? void 0 : _obj$tx.module) != 'Wordblocks') {
            return null;
          }
          var tx = obj.tx;
          var notification = obj.notification;

          //Add from.
          var from = this.app.keychain.returnIdentifierByPublicKey(tx.from[0].publicKey, true);
          notification.title = 'Saito Wordblocks';
          notification.tags = ['game', 'turn'];
          switch (tx.msg.request) {
            case 'join':
              notification.message = from + ' has joined your Wordblocks Game.\n';
              break;
            case 'game':
              notification.message = from + ' has played.\n';
              break;
          }
          var url = "".concat(this.app.server.server.url, "/").concat(this.returnSlug(), "/");
          url += "#gid=".concat(encodeURIComponent(tx.msg.game_id));
          notification.actions = [{
            action: 'view',
            label: 'Play',
            url: url
          }];
          return notification;
        default:
          return _superPropGet(Wordblocks, "respondTo", this, 3)([type, obj]);
      }
    }
  }, {
    key: "initializeGame",
    value: function initializeGame(game_id) {
      var _this2 = this;
      this.game.playerNames = [];
      for (var _i4 = 0; _i4 < this.game.players.length; _i4++) {
        this.game.playerNames.push(this.app.keychain.returnUsername(this.game.players[_i4]));
      }

      //
      // deal cards
      //
      if (this.game.deck.length == 0 && this.game.step.game == 0) {
        //Set a flag to keep processing moves until ready for gameover state
        this.game.canProcess = false;
        this.game.status = 'Generating the Game';
        this.hud.updateStatus(this.game.status);
        this.hud.updateMenu([]);
        this.hud.updateCards([]);
        this.game.queue = [];
        this.game.queue.push('READY');
        for (var _i5 = this.game.players.length; _i5 > 0; _i5--) {
          this.game.queue.push("DEAL\t1\t".concat(_i5, "\t7"));
        }
        this.game.queue.push('SHUFFLE\t1');
        for (var _i6 = this.game.players.length; _i6 > 0; _i6--) {
          this.game.queue.push("DECKENCRYPT\t1\t".concat(_i6));
        }
        for (var _i7 = this.game.players.length; _i7 > 0; _i7--) {
          this.game.queue.push("DECKXOR\t1\t".concat(_i7));
        }
        this.game.queue.push('DECK\t1\t' + JSON.stringify(this.returnDeck()));
      }
      this.getPlayerScore(0); //initialize playerscore variable if not already existing
      this.getLastMove(0); //initialize lastmove variable if not already existing

      this.letters = this.returnLetters();

      //
      // stop here if initializing
      //
      if (/*this.game.initializing == 1 ||*/!this.gameBrowserActive()) {
        return;
      }
      console.log('InitializeGame Checkpoint');

      // To do... if playing Worblocks in Spanish and SOWPODS, need to be able to swap...
      if (this.wordlist == '') {
        //TODO -- Dynamically read letter tiles so wordblocks can more easily add new languages
        try {
          var dictionary = this.game.options.dictionary;
          var durl = '/wordblocks/dictionaries/' + dictionary + '/' + dictionary + '.json';
          var xhr = new XMLHttpRequest();
          xhr.open('GET', durl, true); //true -> async
          xhr.responseType = 'json'; //only in async
          xhr.send();
          this.loadingDictionary = true; //flag that the game module is processing xhr
          xhr.onload = function () {
            if (xhr.status != 200) {
              salert("Network issues downloading dictionary -- ".concat(durl));
            } else {
              _this2.loadingDictionary = false;
              _this2.wordlist = xhr.response; //;Array.from(JSON.parse(xhr.response));
              //console.log("\n\n\nDOWNLOADED WORDLIST: " + JSON.parse(JSON.stringify(xhr.response)));
              //console.log("My word list is a :", typeof this.wordlist);
              _this2.restartQueue();
            }
          };
        } catch (err) {
          // instead of onerror
          console.error(err);
          salert('Network issues downloading dictionary, error caught');
        }
      }
      if (!this.game.state) {
        this.game.state = {};
        this.game.state.newLetters = [];
      }

      //
      // load any existing tiles
      //
      if (this.game.board == undefined) {
        //
        // new board
        //
        this.game.board = this.returnBoard();
      }

      //
      // Draw board
      //
      for (var i in this.game.board) {
        var divname = '#' + i;
        var letter = this.game.board[i].letter; // $(divname).html(this.returnTile(letter));
        this.addTile($(divname), letter);
        if (!(letter == '_') && !(letter == '')) {
          try {
            if (this.game.state.newLetters.includes(i)) {
              $(divname).addClass('new');
            }
            $(divname).addClass('set');
            this.letters[letter].count--;
          } catch (err) {}
        }
      }

      //
      // has a move been made
      //
      for (var _i8 = 1; _i8 < 16; _i8++) {
        for (var k = 1; k < 16; k++) {
          var _boardslot = _i8 + '_' + k;
          if (this.game.board[_boardslot].letter != '_') {
            this.firstmove = 0;
          }
        }
      }

      /*This starts the game*/
      console.log('Initialize Game, Queue:', this.game.queue);
      if (this.game.queue.length == 0) {
        if (this.game.target == this.game.player) {
          this.updateStatusWithTiles('YOUR GO! ' + this.defaultMsg);
          this.setPlayerActive();
          this.enableEvents();
        } else {
          this.updateStatusWithTiles("Waiting on ".concat(this.game.playerNames[this.game.target - 1]));
        }
      }
      $('.score.active').removeClass('active');
      this.playerbox.setActive(this.game.target);
      $("#mobile_score_".concat(this.game.target)).addClass('active');
      if (this.game.players.length > 2) {
        this.grace_window = this.game.players.length * 8;
      }
    }

    /*
     A utility function to return the given players score with ample validity checking and dynamic creation of property
     */
  }, {
    key: "getPlayerScore",
    value: function getPlayerScore(player) {
      if (this.game.score == undefined) {
        this.game.score = [];
        for (var i = 0; i < this.game.players.length; i++) {
          this.game.score[i] = 0;
        }
        return 0;
      } else {
        if (player >= 1 && player <= this.game.players.length) {
          return this.game.score[player - 1];
        }
      }
      return 0;
    }

    /*
     A utility function to return the given players last played word with ample validity checking and dynamic creation of property
     */
  }, {
    key: "getLastMove",
    value: function getLastMove(player) {
      if (this.game.words_played == undefined) {
        this.game.words_played = [];
        for (var i = 0; i < this.game.players.length; i++) {
          this.game.words_played[i] = [];
        }
      } else {
        if (player >= 1 && player <= this.game.players.length) {
          var playersMoves = this.game.words_played[player - 1];
          if (playersMoves.length > 0) {
            return playersMoves[playersMoves.length - 1];
          }
        }
      }
      return {
        word: '',
        score: 0
      };
    }
  }, {
    key: "updateStatusWithTiles",
    value: function updateStatusWithTiles(status) {
      if (this.game.player == 0) {
        this.game.status = "<div class=\"hud-status-update-message\">".concat(status, "</div>");
        this.hud.updateStatus(this.game.status);
        this.hud.updateMenu([]);
        this.hud.updateCards([]);
        return;
      }
      try {
        var tile_html = '';
        for (var i = 0; i < this.game.deck[0].hand.length; i++) {
          tile_html += this.returnTileHTML(this.game.deck[0].cards[this.game.deck[0].hand[i]].name);
        }
        if (!this.gameBrowserActive()) {
          this.game.status = status + tile_html;
          this.hud.updateStatus(this.game.status);
          this.hud.updateMenu([]);
          this.hud.updateCards([]);
          return;
        }
        var html = "\n      <div class=\"hud-status-update-message\">".concat(status, "</div>\n      <div class=\"status_container\">\n        <div class=\"rack\" id=\"rack\">\n          <div class=\"tiles\" id=\"tiles\">\n            ").concat(tile_html, "\n          </div>\n        </div>\n        <div class=\"subrack\" id=\"subrack\">\n          <div class=\"rack-controls\">\n            <div id=\"shuffle\" class=\"shuffle\">Shuffle: <i class=\"fa fa-random\"></i></div>\n            <div id=\"canceldelete\" class=\"hidden\">Cancel: <i id=\"canceldelete\" class=\"far fa-window-close\"></i></div>\n            <div id=\"deletectrl\" class=\"deletectrl hidden\">Discard: <i class=\"fa fa-trash\" id=\"delete\"></i></div>\n            <div id=\"remainingctrl\" >Tiles: ").concat(this.game.deck[0].crypt.length, "</div>\n            <div id=\"skipturn\" class=\"hidden\">Skip: <i class=\"fas fa-fast-forward\"></i></div>\n          </div>\n        </div>\n      </div>\n    ");
        this.game.status = html;
        this.hud.updateStatus(this.game.status);
        this.hud.updateMenu([]);
        this.hud.updateCards([]); //Attach html to #status box
        this.limitedEvents(); //Baseline functionality
      } catch (err) {
        console.error(err);
        console.log('HAND: ' + JSON.stringify(this.game.deck[0].hand));
        console.log('CARDS: ' + JSON.stringify(this.game.deck[0].cards));
      }
    }
  }, {
    key: "returnTileHTML",
    value: function returnTileHTML(letter) {
      var html = '';
      var letterScore = this.returnLetters();
      if (letterScore[letter]) {
        //html =`<div class="tile ${letter} sc${letterScore[letter].score}">${letter}</div>`;
        html = "<div class=\"tile\"><div class=\"letter sc".concat(letterScore[letter].score, "\">").concat(letter, "</div></div>");
      }
      return html;
    }
  }, {
    key: "addTile",
    value: function addTile(obj, letter) {
      obj.find('.tile').remove();
      if (letter !== '_') {
        obj.find('.bonus').css('display', 'none');
        obj.append(this.returnTileHTML(letter));
      } else {
        obj.find('.bonus').css('display', 'flex');
      }
    }

    /*
     Basic events for all players to interact with their hud even when not their turn
     */
  }, {
    key: "limitedEvents",
    value: function limitedEvents() {
      var wordblocks_self = this;
      if (this.gameBrowserActive()) {
        $('.gameboard').removeClass('active_board');
        $('.slot').off();
        $('#rack .tile').off();
        $('#tiles').disableSelection();
        //Drag to Sort tiles on Rack
        $('#tiles').sortable({
          axis: 'x',
          tolerance: 'pointer',
          containment: 'parent',
          distance: 3,
          start: function start(event, ui) {
            $(ui.item).addClass('noclick');
          },
          stop: function stop(event, ui) {
            setTimeout(function () {
              $(ui.item).removeClass('noclick');
            }, 350);
          }
        });

        //Shuffle Rack
        $('#shuffle').on('click', function () {
          for (var i = $('#tiles').children.length; i >= 0; i--) {
            $('#tiles')[0].appendChild($('#tiles')[0].childNodes[Math.random() * i | 0]);
          }
        });
        $('#remainingctrl').on('click', function () {
          wordblocks_self.displayRemainingTiles();
        });

        /* Click to popup more information on what the last move just was */
        var _loop = function _loop(i) {
          var handle = '#lastmove_' + i;
          $(handle).off();
          $(handle).on('click', function () {
            if (wordblocks_self.last_played_word[i - 1] && wordblocks_self.last_played_word[i - 1].play) {
              wordblocks_self.overlay.show(wordblocks_self.returnMath(wordblocks_self.last_played_word[i - 1].play));
            }
          });
        };
        for (var i = 1; i <= this.game.players.length; i++) {
          _loop(i);
        }
      }
    }
  }, {
    key: "removeEvents",
    value: function removeEvents() {
      if (this.gameBrowserActive()) {
        $('#skipturn').off();
        $('#shuffle').off(); //Don't want to shuffle when manually placing tiles or deleting
        $('.slot').off(); //Reset clicking on board
        $('.tosstiles').off();
        $('#rack .tile').off();
        $('#deletectrl').off();
        $('#status').off();
        $('#canceldelete').off();
        $('.tile').off();
        $('.selected_space').removeClass('selected_space');
        $('.gameboard').removeClass('active_board');
      }
    }
  }, {
    key: "enableEvents",
    value: function enableEvents() {
      if (this.gameBrowserActive()) {
        this.addEventsToBoard();
        $('.gameboard').addClass('active_board');
      }
    }

    /*
       Create event listeners for user interaction
       We have various modes, which when changed need to call this function again to refresh the event model
       hud-status-update-message
     */
  }, {
    key: "addEventsToBoard",
    value: function () {
      var _addEventsToBoard = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var wordblocks_self, tile, interactiveMode, revertToPlay, selectTile, deselectTile, returnToRack, checkBoard, xpos, ypos;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (this.gameBrowserActive()) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              $('.selected_space').removeClass('selected_space');
              wordblocks_self = this;
              tile = document.querySelector('.highlighttile');
              interactiveMode = document.querySelector('.slot .tempplacement') || document.querySelector('#tiles .highlighttile');
              $('#remainingctrl').on('click', function () {
                wordblocks_self.displayRemainingTiles();
              });
              try {
                //Show delete and skip controls
                if (this.game.deck[0].crypt.length > 0) {
                  $('#deletectrl').removeClass('hidden');
                }
                $('#skipturn').removeClass('hidden');

                /*
                   Define a few helper functions because there are multiple ways to get to the same code
                   */
                revertToPlay = function revertToPlay() {
                  //Unselect all double-clicked tiles
                  $('.tiles .tile').removeClass('todelete');
                  $('#shuffle').removeClass('hidden');
                  $('#tiles').sortable('enable');
                  $('#canceldelete').addClass('hidden');
                  $('#deletectrl').off();
                  $('#canceldelete').off();
                  wordblocks_self.addEventsToBoard();
                };
                selectTile = function selectTile(selection, e) {
                  $('.highlighttile').removeClass('highlighttile');
                  tile = selection;
                  $(tile).addClass('highlighttile');
                  var helper = tile.cloneNode(true);
                  helper.id = 'helper';
                  $(document.body).append(helper);
                  $('#helper').css({
                    top: e.clientY - 25,
                    left: e.clientX - 25
                  });
                  $('#status').on('click', function () {
                    //console.log("*** Click on rack ***");
                    returnToRack(tile);
                  });
                };
                deselectTile = function deselectTile() {
                  $('.highlighttile').removeClass('highlighttile');
                  tile = null;
                  $('#helper').remove();
                  $('#status').off();
                };
                returnToRack = function returnToRack(tile) {
                  var slot = tile.parentElement.id;
                  $('#tiles').append(tile);
                  $(tile).removeClass('tempplacement');
                  //console.log("slot: " + slot);
                  deselectTile();
                  if (slot != 'tiles') {
                    wordblocks_self.game.board[slot].letter = '_';
                    //Show bonus information if uncovered
                    $("#".concat(slot)).find('.bonus').css('display', 'flex');
                    checkBoard(); //Helper function to display submission button if deleting this tile gives us a "playable" word
                  }

                  //if (!(document.querySelector(".slot .tempplacement") || document.querySelector("#tiles .highlighttile"))) {
                  wordblocks_self.addEventsToBoard();
                  //}
                };
                checkBoard = function checkBoard() {
                  $('.tile-submit-controls').remove(); //Removes previous addition
                  //Popup to commit word
                  //Get the x,y, orientation and word from tiles
                  var _wordblocks_self$read = wordblocks_self.readWordFromBoard(),
                    _wordblocks_self$read2 = _slicedToArray(_wordblocks_self$read, 4),
                    word = _wordblocks_self$read2[0],
                    orientation = _wordblocks_self$read2[1],
                    y = _wordblocks_self$read2[2],
                    x = _wordblocks_self$read2[3];
                  if (word) {
                    var html = "\n            <div class=\"tile-submit-controls\">\n              <div class=\"playable ".concat(wordblocks_self.checkWord(word) ? 'valid_word' : 'invalid_word', "\">").concat(word, "</div>\n              <div class=\"action\" id=\"cancel\"><i class=\"far fa-window-close\"></i> Cancel</div>\n              <div class=\"action\" id=\"submit\"><i class=\"fa fa-paper-plane\"></i> Submit</div>\n            </div>");

                    //Change this because stupid game-playerbox-manager not opponent box
                    $('.hud').append(html);
                    $('.action').off();
                    $('.action').on('click', function () {
                      $('.action').off();
                      $('.tile-submit-controls').remove();
                      //Remove the temporary tiles
                      wordblocks_self.clearBoard();
                      if ($(this).attr('id') == 'submit') {
                        //console.log(`Submitting ${word}, ${orientation} at column ${x}, row ${y}`);
                        wordblocks_self.tryPlayingWord(x, y, orientation, word);
                      } else {
                        //reload events
                        wordblocks_self.addEventsToBoard();
                      }
                    });
                  }
                };
                $('#skipturn').off();
                $('#skipturn').on('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                  var c;
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.n) {
                      case 0:
                        _context2.n = 1;
                        return sconfirm('Are you sure you want to end your turn without playing?');
                      case 1:
                        c = _context2.v;
                        if (c) {
                          wordblocks_self.clearBoard();
                          wordblocks_self.addMove('discard_tiles\t' + wordblocks_self.game.player + '\t');
                          wordblocks_self.endTurn();
                        }
                      case 2:
                        return _context2.a(2);
                    }
                  }, _callee2);
                })));

                //Float helper tile with mouse over board
                $(document).on('mousemove', function (e) {
                  //$("#helper").css("transform",`translate(${e.clientX+5}px, ${e.clientY+5}px)`);
                  $('#helper').css({
                    top: e.clientY - 25,
                    left: e.clientX - 25
                  });
                });
                $('#shuffle').off(); //Don't want to shuffle when manually placing tiles or deleting
                $('.slot').off(); //Reset clicking on board

                $('#rack .tile').off();
                //Single click to select a tile and enter interactive placement mode
                $('#rack .tile').on('click', function (e) {
                  if (!$(this).hasClass('noclick')) {
                    //Wasn't just dragging this tile and triggering a click event
                    if (tile == this) {
                      deselectTile();
                    } else {
                      deselectTile();
                      if (!$(this).hasClass('highlighttile')) {
                        //console.log("Selection: " + this);
                        selectTile(this, e); //Helper function to create floating tile
                      }
                    }

                    //Reload events if changing input model
                    if (interactiveMode != (document.querySelector('.slot .tempplacement') || document.querySelector('#tiles .highlighttile'))) wordblocks_self.addEventsToBoard();
                  }
                  e.stopPropagation();
                });

                //Discard Tiles -- Method 2
                $('#deletectrl').off();
                $('#deletectrl').on('click', function () {
                  wordblocks_self.clearBoard();
                  //Enter interactive discard mode.
                  $('.hud-status-update-message').text('Select the tiles you want to discard and click the trash icon to confirm (this will count as your turn).');
                  $('#tiles').sortable('disable');
                  $('.tile').off('click'); //block clicking
                  $('#shuffle').addClass('hidden');
                  $('#canceldelete').removeClass('hidden');
                  //Single click to select for deletion
                  $('#rack .tile').on('click', function (e) {
                    this.classList.toggle('todelete');
                  });
                  $('#canceldelete').off();
                  $('#canceldelete').on('click', revertToPlay);
                  $('#deletectrl').off();
                  $('#deletectrl').on('click', function () {
                    var deletedTiles = '';
                    var tileRack = document.querySelectorAll('.tiles .tile');
                    for (var i = 0; i < tileRack.length; i++) {
                      if (tileRack[i].classList.contains('todelete')) deletedTiles += tileRack[i].textContent;
                    }
                    if (deletedTiles && deletedTiles.length <= wordblocks_self.game.deck[0].crypt.length) {
                      wordblocks_self.discardAndDrawTiles(deletedTiles);
                    } else {
                      //salert('You must discard at least one tile and no more than are available to draw!');
                      revertToPlay();
                    }
                  });
                });

                /*$("#rack .tile").on("dblclick", function () {
                     //Toggle deleted on/off with each double click
                     this.classList.toggle("todelete");
                     //Do we have tiles selected for deletion?
                     let deletedTiles = "";
                     let tileRack = document.querySelectorAll(".tiles .tile");
                     for (let i = 0; i < tileRack.length; i++) {
                       if (tileRack[i].classList.contains("todelete"))
                         deletedTiles += tileRack[i].textContent;
                     }
                      //If tiles selected for deletion enter deletemode
                     if (deletedTiles.length > 0) {
                       $(".hud-status-update-message").text(
                         "Select the tiles you want to discard and click the trash icon to confirm (this will count as your turn)."
                       );
                        $("#tiles").sortable("disable");
                       $(".tile").off("click"); //block clicking
                       $("#canceldelete").removeClass("hidden");
                       $("#delete").off();
                       $("#delete").on("click", function () {
                         wordblocks_self.discardAndDrawTiles(deletedTiles);
                       });
                       $("#canceldelete").off();
                       $("#canceldelete").on("click", revertToPlay);
                     } else {
                       //Exit deletemode
                       revertToPlay();
                     }
                   });*/

                /*
                   Default/Original mode
                   Allow shuffling of rack and click on board to launch text entry
                   */
                if (!interactiveMode) {
                  xpos = 0;
                  ypos = 0;
                  $('#helper').remove(); //clean up just in case
                  $('.hud-status-update-message').html(wordblocks_self.defaultMsg); //update instructions to player
                  //Click on game board to type a word

                  $('.slot').on('mousedown', function (e) {
                    xpos = e.clientX;
                    ypos = e.clientY;
                  });
                  //Create as menu on the game board to input word from a tile in horizontal or vertical direction
                  $('.slot').on('mouseup', function (e) {
                    if (Math.abs(xpos - e.clientX) > 4) {
                      return;
                    }
                    if (Math.abs(ypos - e.clientY) > 4) {
                      return;
                    }
                    $('.selected_space').removeClass('selected_space');
                    $(this).addClass('selected_space');
                    var divname = $(this).attr('id');
                    var html = "\n            <div class=\"tile-placement-controls\">\n              <div class=\"action\" id=\"horizontal\"><i class=\"fas fa-arrows-alt-h\"></i> horizontally</div>\n              <div class=\"action\" id=\"vertical\"><i class=\"fas fa-arrows-alt-v\"></i> vertically</div>\n              <div class=\"action\" id=\"cancel\"><i class=\"far fa-window-close\"></i> cancel</div>\n            </div>";
                    var tmpx = divname.split('_');
                    var y = tmpx[0];
                    var x = tmpx[1];
                    var word = '';
                    var offsetX = wordblocks_self.app.browser.isMobileBrowser(navigator.userAgent) ? 25 : 55;
                    var offsetY = wordblocks_self.app.browser.isMobileBrowser(navigator.userAgent) ? 25 : 55;
                    var greater_offsetX = wordblocks_self.app.browser.isMobileBrowser(navigator.userAgent) ? 135 : 155;
                    var greater_offsetY = wordblocks_self.app.browser.isMobileBrowser(navigator.userAgent) ? 135 : 155;
                    var left = $(this).offset().left + offsetX;
                    var top = $(this).offset().top + offsetY;
                    if (x > 8) {
                      left -= greater_offsetX;
                    }
                    if (y > 8) {
                      top -= greater_offsetY;
                    }
                    $('.tile-placement-controls').remove(); //Removes previous addition

                    $('body').append(html);
                    $('.tile-placement-controls').css({
                      top: top,
                      left: left,
                      bottom: 'unset',
                      right: 'unset'
                    });

                    //Launch asynch prompt for typed word
                    $('.action').off();
                    $('.action').on('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                      var orientation;
                      return _regenerator().w(function (_context3) {
                        while (1) switch (_context3.n) {
                          case 0:
                            $('.tile-placement-controls').remove();
                            orientation = $(this).attr('id'); //horizontal, vertical, cancel
                            if (!(orientation == 'cancel')) {
                              _context3.n = 1;
                              break;
                            }
                            wordblocks_self.updateStatusWithTiles(wordblocks_self.defaultMsg);
                            wordblocks_self.enableEvents();
                            return _context3.a(2);
                          case 1:
                            _context3.n = 2;
                            return sprompt('Provide your word:');
                          case 2:
                            word = _context3.v;
                            $('.selected_space').removeClass('selected_space');
                            //Process Word
                            if (word) {
                              //console.log(`Submitting ${word}, ${orientation} at col ${x}, row ${y}`);
                              wordblocks_self.tryPlayingWord(x, y, orientation, word);
                            }
                          case 3:
                            return _context3.a(2);
                        }
                      }, _callee3, this);
                    })));
                  });

                  /* 
                    Enable shuffling in this mode 
                    */
                  $('#shuffle').on('click', function () {
                    for (var i = $('#tiles').children.length; i >= 0; i--) {
                      $('#tiles')[0].appendChild($('#tiles')[0].childNodes[Math.random() * i | 0]);
                    }
                  });
                } else {
                  //Alternate tile manipulation event model:     interactive placement

                  $('.hud-status-update-message').text('Click a tile to select/deselect it, then click the board to place it. Double click to move it back to the rack');
                  $('.tile-placement-controls').remove();
                  $('#rack .tile').off('dblclick'); //Turn off dbl click to delete

                  //Double click to remove from board
                  $('.slot').on('dblclick', function () {
                    var clkTarget = this.querySelector('.tile');
                    if (clkTarget && $(clkTarget).hasClass('tempplacement')) {
                      returnToRack(clkTarget /*, $(this).attr("id")*/);
                    } else {
                      //console.log(JSON.parse(JSON.stringify(wordblocks_self.game.board)));
                    }
                  });
                  //Click rack when tile is selected to return it to rack

                  //Click slot to move tile on board
                  $('.slot').on('click', function (e) {
                    //do we have a tile selected

                    //Is there a tile to select?
                    if (this.querySelector('.tile')) {
                      //Will select tile first
                      var conflict = this.querySelector('.tile');
                      if (conflict.classList.contains('tempplacement')) {
                        if (!tile) {
                          //If we don't have a currently selected tile
                          //console.log(`Select new at (${$(this).attr("id")}):`, tile, conflict);
                          selectTile(conflict, e);
                        } else if (conflict.classList.contains('highlighttile')) {
                          //Toggle selection of tile
                          //console.log(`Deselect (${$(this).attr("id")}):`, tile, conflict);
                          deselectTile();
                        } else {
                          //console.log("Swap selection:", tile, conflict);
                          deselectTile();
                          selectTile(conflict, e);
                        }
                      }
                    } else {
                      //Slot is empty
                      if (tile) {
                        //Fill in board
                        wordblocks_self.game.board[$(this).attr('id')].letter = tile.textContent;
                        //Remove from board (if necessary)
                        var parentSlot = $('.slot .highlighttile').parent().attr('id');
                        if (parentSlot) {
                          wordblocks_self.game.board[parentSlot].letter = '_';
                        }

                        //Move tile if we have one selected
                        //Hide bonus information if covered
                        if (this.querySelector('.bonus')) {
                          this.querySelector('.bonus').style.display = 'none';
                        } //Show bonus information if uncovered
                        if (tile.parentElement.querySelector('.bonus')) {
                          tile.parentElement.querySelector('.bonus').style.display = 'flex';
                        }
                        //Move tile to board
                        this.append(tile);
                        $(tile).addClass('tempplacement');
                        $(tile).off();
                        deselectTile();
                      }
                    }
                    checkBoard();
                  });
                  checkBoard();
                }

                //Discard Tiles -- Old Method
                //Must be added here because maybe refreshing the hud-status-message
                $('.tosstiles').off();
                $('.tosstiles').on('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
                  var tmphand, i, letter, letter_found, k;
                  return _regenerator().w(function (_context4) {
                    while (1) switch (_context4.n) {
                      case 0:
                        if (!(wordblocks_self.game.deck[0].crypt.length > 0)) {
                          _context4.n = 7;
                          break;
                        }
                        _context4.n = 1;
                        return sprompt('Which tiles do you want to discard?');
                      case 1:
                        tiles = _context4.v;
                        if (!tiles) {
                          _context4.n = 6;
                          break;
                        }
                        if (!(tiles.length > wordblocks_self.game.deck[0].crypt.length)) {
                          _context4.n = 2;
                          break;
                        }
                        salert('INVALID: You cannot throw away more letters than you can draw');
                        return _context4.a(2, false);
                      case 2:
                        tmphand = JSON.parse(JSON.stringify(wordblocks_self.game.deck[0].hand));
                        i = 0;
                      case 3:
                        if (!(i < tiles.length)) {
                          _context4.n = 5;
                          break;
                        }
                        letter = tiles[i].toUpperCase();
                        letter_found = 0;
                        for (k = 0; k < tmphand.length; k++) {
                          if (wordblocks_self.game.deck[0].cards[tmphand[k]].name == letter) {
                            tmphand.splice(k, 1);
                            letter_found = 1;
                            k = tmphand.length + 1;
                          }
                        }
                        if (!(letter_found == 0)) {
                          _context4.n = 4;
                          break;
                        }
                        salert('INVALID: letter not in hand: ' + letter);
                        return _context4.a(2, false);
                      case 4:
                        i++;
                        _context4.n = 3;
                        break;
                      case 5:
                        wordblocks_self.discardAndDrawTiles(tiles);
                      case 6:
                        _context4.n = 8;
                        break;
                      case 7:
                        salert('You can only discard if there are tiles to draw');
                      case 8:
                        return _context4.a(2);
                    }
                  }, _callee4);
                })));
              } catch (err) {
                console.log(err);
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function addEventsToBoard() {
        return _addEventsToBoard.apply(this, arguments);
      }
      return addEventsToBoard;
    }()
    /*
     Move all temporary tiles from board back to rack
    */
  }, {
    key: "clearBoard",
    value: function clearBoard() {
      $('.tile-submit-controls').remove();
      $('#helper').remove();
      var playedTiles = document.querySelectorAll('.slot .tempplacement');
      var _iterator2 = _createForOfIteratorHelper(playedTiles),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var t = _step2.value;
          this.game.board[t.parentElement.id].letter = '_';
          if (t.parentElement.querySelector('.bonus')) {
            t.parentElement.querySelector('.bonus').style.display = 'flex';
          }
          $('#tiles').append(t);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }

    /*
     Scan for the board to find a consecutive arrangement of temporary tiles
     Returns: Word, orientation, x, y (of starting square)
    */
  }, {
    key: "readWordFromBoard",
    value: function readWordFromBoard() {
      var playedTiles = document.querySelectorAll('.slot .tempplacement');
      var minx = 16,
        miny = 16,
        maxx = 0,
        maxy = 0;
      var word = '';
      var orientation = '';
      var fail = false;
      if (playedTiles.length === 1) {
        var _playedTiles$0$parent = playedTiles[0].parentElement.id.split('_'),
          _playedTiles$0$parent2 = _slicedToArray(_playedTiles$0$parent, 2),
          r = _playedTiles$0$parent2[0],
          c = _playedTiles$0$parent2[1];
        minx = parseInt(r);
        miny = parseInt(c);
        //console.log(`1 tile at ${r}_${c}`);
        var _this$expandWord = this.expandWord(r, c, 'horizontal');
        word = _this$expandWord.word;
        miny = _this$expandWord.miny;
        minx = _this$expandWord.minx;
        if (word.length > 1) {
          orientation = 'horizontal';
          return [word, orientation, miny, minx];
        }
        var _this$expandWord2 = this.expandWord(r, c, 'vertical');
        word = _this$expandWord2.word;
        miny = _this$expandWord2.miny;
        minx = _this$expandWord2.minx;
        if (word.length > 1) {
          orientation = 'vertical';
          return [word, orientation, miny, minx];
        }
        return ['', 'invalid', miny, minx];
      } else {
        //Have guaranteed orientation for main axis
        var _iterator3 = _createForOfIteratorHelper(playedTiles),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var t = _step3.value;
            var _t$parentElement$id$s = t.parentElement.id.split('_'),
              _t$parentElement$id$s2 = _slicedToArray(_t$parentElement$id$s, 2),
              x = _t$parentElement$id$s2[0],
              y = _t$parentElement$id$s2[1];
            x = parseInt(x);
            y = parseInt(y);
            if (x > maxx) maxx = x;
            if (x < minx) minx = x;
            if (y > maxy) maxy = y;
            if (y < miny) miny = y;
          }
          //console.log(minx,miny,"---",maxx,maxy);
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        if (maxx == minx) {
          orientation = 'horizontal';
          for (var i = miny; i <= maxy; i++) {
            var slot = maxx + '_' + i;
            var div = document.getElementById(slot);
            if (div) {
              if (div.querySelector('.tile')) {
                word += div.querySelector('.tile').textContent;
              } else fail = true;
            } else fail = true;
          }
        } else if (maxy == miny) {
          orientation = 'vertical';
          for (var _i9 = minx; _i9 <= maxx; _i9++) {
            var _slot = _i9 + '_' + maxy;
            var _div = document.getElementById(_slot);
            if (_div) {
              if (_div.querySelector('.tile')) {
                word += _div.querySelector('.tile').textContent;
              } else fail = true;
            } else fail = true;
          }
        } else {
          //orientation  "invalid";
          fail = true;
        }
        if (fail) return ['', 'invalid', miny, minx];
        //console.log(`Expanding from temporary tiles (${orientation})`);
        var _this$expandWord3 = this.expandWord(minx, miny, orientation);
        word = _this$expandWord3.word;
        miny = _this$expandWord3.miny;
        minx = _this$expandWord3.minx;
        return [word, orientation, miny, minx];
      }
    }

    /*
     See if a word fits in the spot and score it if so...
    */
  }, {
    key: "tryPlayingWord",
    value: function tryPlayingWord(x, y, orientation, word) {
      word = word.toUpperCase();
      //console.log(`Y:${y}_X:${x},  ${orientation}, ${word}`);
      // reset board
      $('.tile-placement-controls').html('');
      //$(".status").html("Processing your turn.");

      // if entry is valid (position and letters available)
      if (this.isEntryValid(word, orientation, x, y)) {
        var myscore = 0;
        this.addWordToBoard(word, orientation, x, y);

        //Orientation check for single tile plays...
        var fullword = this.expandWord(y, x, orientation).word;
        //console.log("Expanded word:",fullword);
        if (fullword.length == 1) {
          var newOrientation = orientation == 'vertical' ? 'horizontal' : 'vertical';
          if (this.expandWord(y, x, newOrientation).word.length > 1) {
            this.removeWordFromBoard(word, orientation, x, y);
            this.tryPlayingWord(x, y, newOrientation, word);
            return;
          } //Otherwise just let it fail with normal logic
        }
        myscore = this.scorePlay(word, this.game.player, orientation, x, y);
        if (myscore <= 1) {
          //If not found in dictionary
          this.removeWordFromBoard(word, orientation, x, y);
          this.updateStatusWithTiles("Not a valid word, try again! ".concat(this.defaultMsg));
          this.enableEvents();
        } else {
          this.game.words_played[parseInt(this.game.player) - 1].push({
            word: fullword,
            score: myscore
          });
          this.updateLog("You played ".concat(fullword, " for ").concat(myscore, " points."));
          //
          // discard tiles
          // (not really a discard, just changing flags on the board spaces to enable scoring??)
          //this.discardTiles(word, orientation, x, y);
          //Lock in Move in the DOM
          //this.setBoard(word, orientation, x, y);
          this.discardTiles(word, orientation, x, y); //remove Played tiles from Hand
          this.finalizeWord(word, orientation, x, y); //update board
          this.addScoreToPlayer(this.game.player, myscore);
          this.drawTiles();
          this.addMove("place\t".concat(word, "\t").concat(this.game.player, "\t").concat(x, "\t").concat(y, "\t").concat(orientation, "\t").concat(fullword));
          if (this.checkForEndGame() == 1) {
            this.prependMove('gameover');
          }
          this.endTurn();
        }
      } else {
        //!isEntryValid
        this.updateStatusWithTiles("Not a valid word, try again! ".concat(this.defaultMsg));
        this.enableEvents();
      }
    }
  }, {
    key: "drawTiles",
    value: function drawTiles() {
      var cards_needed = 7;
      cards_needed = cards_needed - this.game.deck[0].hand.length;
      if (cards_needed > this.game.deck[0].crypt.length) {
        this.prependMove("report_tiles\t".concat(this.game.player, "\t").concat(this.game.deck[0].hand.length + this.game.deck[0].crypt.length));
        cards_needed = this.game.deck[0].crypt.length;
      }
      if (cards_needed > 0) {
        this.addMove('DEAL\t1\t' + this.game.player + '\t' + cards_needed);
      }
    }

    /*
     Main call for deleting some tiles from the players rack, having them draw new tiles, and ending their turn
    */
  }, {
    key: "discardAndDrawTiles",
    value: function discardAndDrawTiles(tiles) {
      salert('Tossed: ' + tiles);
      this.removeTilesFromHand(tiles);
      this.drawTiles();
      this.addMove('discard_tiles\t' + this.game.player + '\t' + tiles);
      this.endTurn();
    }
  }, {
    key: "removeTilesFromHand",
    value: function removeTilesFromHand(word) {
      while (word.length > 0) {
        var tmpx = word[0];
        tmpx = tmpx.toUpperCase();
        for (var i = 0; i < this.game.deck[0].hand.length; i++) {
          if (this.game.deck[0].cards[this.game.deck[0].hand[i]].name == tmpx) {
            this.game.deck[0].hand.splice(i, 1);
            i = this.game.deck[0].hand.length;
          }
        }
        if (word.length > 1) {
          word = word.substring(1);
        } else {
          word = '';
        }
      }
    }
  }, {
    key: "isEntryValid",
    value: function isEntryValid(word, orientation, x, y) {
      var _this3 = this;
      var tmphand = JSON.parse(JSON.stringify(this.game.deck[0].hand));
      x = parseInt(x);
      y = parseInt(y);

      //
      // if this is the first word, it has to cross a critical star
      //
      if (this.firstmove == 1) {
        if (orientation == 'vertical') {
          if (x != 6 && x != 10) {
            salert('First Word must be placed to cross a Star');
            return false;
          }
          var starting_point = y;
          var ending_point = y + word.length - 1;
          if (starting_point <= 6 && ending_point >= 6 || starting_point <= 10 && ending_point >= 10) {} else {
            salert('First Word must be long enough to cross a Star');
            return false;
          }
        }
        if (orientation == 'horizontal') {
          if (y != 6 && y != 10) {
            salert('First Word must be placed to cross a Star');
            return false;
          }
          var _starting_point = x;
          var _ending_point = x + word.length - 1;
          if (_starting_point <= 6 && _ending_point >= 6 || _starting_point <= 10 && _ending_point >= 10) {} else {
            salert('First Word must be long enough to cross a Star');
            return false;
          }
        } //this.firstmove = 0;
      } else {
        //Check to make sure newly played word touches another word
        // let touchesWord = 0;
        /*let xStart = Math.max(1, x - 1);
           let yStart = Math.max(1, y - 1);
           let xEnd, yEnd;
           if (orientation == "horizontal") {
             xEnd = Math.min(15, x + word.length + 1);
             yEnd = Math.min(15, y + 1);
           } else {
             xEnd = Math.min(15, x + 1);
             yEnd = Math.min(15, y + word.length + 1);
           }
           //// old code
           // for (let i = xStart; i <= xEnd; i++)
           //   for (let j = yStart; j <= yEnd; j++) {
           //     let boardslot = j + "_" + i;
           //     console.log(boardslot)
           //     if (this.game.board[boardslot].fresh == 0) {
           //       touchesWord = 1;
           //       break;
           //     }
           //     console.log(touchesWord)
           //   }
           */
        var _touchesWord = [];
        if (orientation == 'horizontal') {
          var left = "".concat(y, "_").concat(x - 1);
          var right = "".concat(y, "_").concat(x + word.length);
          var allBoardSlots = [[left, right]];
          for (var i = x; i < x + word.length; i++) {
            var top = "".concat(y - 1, "_").concat(i);
            var bottom = "".concat(y + 1, "_").concat(i);
            var neighbors = [top, bottom];
            allBoardSlots.push(neighbors);
          }
          //console.log(allBoardSlots);

          allBoardSlots.forEach(function (neighbor) {
            neighbor.forEach(function (slot) {
              if (_this3.game.board[slot] && _this3.game.board[slot].fresh == 0) {
                _touchesWord.push({
                  touchesWord: true,
                  slot: slot,
                  letter: _this3.game.board[slot]
                });
              }
            });
          });
        }
        if (orientation == 'vertical') {
          var _top = "".concat(y - 1, "_").concat(x);
          var _bottom = "".concat(y + word.length, "_").concat(x);
          var _allBoardSlots = [[_top, _bottom]];
          for (var _i0 = y; _i0 < y + word.length; _i0++) {
            var _left = "".concat(_i0, "_").concat(x - 1);
            var _right = "".concat(_i0, "_").concat(x + 1);
            var _neighbors = [_left, _right];
            _allBoardSlots.push(_neighbors);
          }
          //console.log(allBoardSlots);

          _allBoardSlots.forEach(function (neighbor) {
            neighbor.forEach(function (plane) {
              if (_this3.game.board[plane] && _this3.game.board[plane].fresh == 0) {
                _touchesWord.push({
                  touchesWord: true,
                  plane: plane,
                  letter: _this3.game.board[plane]
                });
              }
            });
          });
        }
        if (!_touchesWord.find(function (item) {
          return item.touchesWord == true;
        })) {
          salert('Word does not cross or touch an existing word.');
          console.log(_touchesWord);
          return false;
        }
      }

      //In all cases, must have the letters in hand or on board to spell word
      var letters_used = 0;
      for (var _i1 = 0; _i1 < word.length; _i1++) {
        var _boardslot2 = '';
        var letter = word[_i1].toUpperCase();
        if (orientation == 'horizontal') {
          _boardslot2 = y + '_' + (x + _i1);
          if (x + _i1 > 15) {
            salert('Word must fit on board!');
            return false;
          }
        }
        if (orientation == 'vertical') {
          _boardslot2 = y + _i1 + '_' + x;
          if (y + _i1 > 15) {
            salert('Word must fit on board!');
            return false;
          }
        }
        if (this.game.board[_boardslot2].letter != '_') {
          if (this.game.board[_boardslot2].letter != letter) {
            salert('Cannot overwrite existing words!');
            return false;
          }
        } else {
          var letter_found = 0;
          letters_used++;
          for (var k = 0; k < tmphand.length; k++) {
            if (this.game.deck[0].cards[tmphand[k]].name == letter) {
              tmphand.splice(k, 1);
              letter_found = 1;
              k = tmphand.length + 1;
            }
          }
          if (letter_found == 0) {
            salert('INVALID: letter not in hand: ' + letter);
            return false;
          }
        }
      }
      if (!letters_used) {
        salert('Must place at least one new tile on board!');
        return false;
      }
      return true;
    }

    //Mark word as no longer new (.fresh is a flag used in scoring)
    //--AND-- remove newly used tiles from players hand
    //--AND-- update DOM classes
  }, {
    key: "finalizeWord",
    value: function finalizeWord(word, orientation, x, y) {
      x = parseInt(x);
      y = parseInt(y);
      $('.new').removeClass('new');
      this.game.state.newLetters = [];
      for (var i = 0; i < word.length; i++) {
        var _boardslot3 = '';
        var divname = '';
        var letter = word[i].toUpperCase();
        if (orientation == 'horizontal') {
          _boardslot3 = y + '_' + (x + i);
        }
        if (orientation == 'vertical') {
          _boardslot3 = y + i + '_' + x;
        }
        divname = '#' + _boardslot3;
        if (this.game.board[_boardslot3] && this.game.board[_boardslot3].fresh == 1) {
          this.game.board[_boardslot3].fresh = 0;
          $(divname).addClass('new');
          this.game.state.newLetters.push(_boardslot3);
          this.letters[letter].count--;
        }
        $(divname).addClass('set');
      }
    }

    /*Discard tiles used to create the given word*/
  }, {
    key: "discardTiles",
    value: function discardTiles(word, orientation, x, y) {
      x = parseInt(x);
      y = parseInt(y);
      for (var i = 0; i < word.length; i++) {
        var _boardslot4 = '';
        var letter = word[i].toUpperCase();
        if (orientation == 'horizontal') {
          _boardslot4 = y + '_' + (x + i);
        }
        if (orientation == 'vertical') {
          _boardslot4 = y + i + '_' + x;
        }
        if (this.game.board[_boardslot4] && this.game.board[_boardslot4].fresh == 1) {
          this.removeTilesFromHand(word[i]);
        }
      }
    }
  }, {
    key: "addLetterToBoard",
    value: function addLetterToBoard(letter, slot) {
      this.game.board[slot].letter = letter.toUpperCase();
    }
  }, {
    key: "removeLetterFromBoard",
    value: function removeLetterFromBoard(slot) {}
    /*
     Updates GUI and game.board with newly played word
     */
  }, {
    key: "addWordToBoard",
    value: function addWordToBoard(word, orientation, x, y) {
      x = parseInt(x);
      y = parseInt(y);
      for (var i = 0; i < word.length; i++) {
        var _boardslot5 = '';
        var divname = '';
        var letter = word[i].toUpperCase();
        if (orientation == 'horizontal') {
          _boardslot5 = y + '_' + (x + i);
        }
        if (orientation == 'vertical') {
          _boardslot5 = y + i + '_' + x;
        }
        divname = '#' + _boardslot5;
        if (this.game.board[_boardslot5].letter != '_') {
          if (this.game.board[_boardslot5].letter != letter) {
            //We can overwrite tiles??
            console.log('UNEXPECTED OUTCOME IN addWordToBoard ******');
            console.log(this.game.board[_boardslot5].letter, letter); //what is going on here?
            this.game.board[_boardslot5].letter = letter;
            this.addTile($(divname), letter);
          }
        } else {
          this.game.board[_boardslot5].letter = letter;
          this.addTile($(divname), letter);
        }
      }
    }

    /*
     Undoes addWordToBoard, updates GUI to remove newly played tiles (as defined by class:set)
     */
  }, {
    key: "removeWordFromBoard",
    value: function removeWordFromBoard(word, orientation, x, y) {
      x = parseInt(x);
      y = parseInt(y);
      for (var i = 0; i < word.length; i++) {
        var _boardslot6 = '';
        var divname = '';
        var letter = word[i].toUpperCase();
        if (orientation == 'horizontal') {
          _boardslot6 = y + '_' + (x + i);
        }
        if (orientation == 'vertical') {
          _boardslot6 = y + i + '_' + x;
        }
        divname = '#' + _boardslot6;
        if ($(divname).hasClass('set') != true) {
          this.game.board[_boardslot6].letter = '_';
          $(divname).find('.tile').remove();
          $(divname).find('.bonus').css('display', 'flex');
        }
      }
    }

    /*
     Board is 1-indexed, 15 Rows and 15 Columns ( y_x)
     */
  }, {
    key: "returnBoard",
    value: function returnBoard() {
      var board = {};
      for (var i = 1; i <= 15; i++) {
        for (var j = 1; j <= 15; j++) {
          var divname = i + '_' + j;
          board[divname] = {
            letter: '_',
            fresh: 1
          };
        }
      }
      return board;
    }
  }, {
    key: "returnDeck",
    value: function returnDeck() {
      var dictionary = this.game.options.dictionary;
      console.log('Dictionary: ' + dictionary);
      if (dictionary === 'twl' || dictionary === 'sowpods') {
        return {
          1: {
            name: 'A'
          },
          2: {
            name: 'A'
          },
          3: {
            name: 'A'
          },
          4: {
            name: 'A'
          },
          5: {
            name: 'A'
          },
          6: {
            name: 'A'
          },
          7: {
            name: 'A'
          },
          8: {
            name: 'A'
          },
          9: {
            name: 'A'
          },
          10: {
            name: 'B'
          },
          11: {
            name: 'B'
          },
          12: {
            name: 'C'
          },
          13: {
            name: 'C'
          },
          14: {
            name: 'D'
          },
          15: {
            name: 'D'
          },
          16: {
            name: 'D'
          },
          17: {
            name: 'D'
          },
          18: {
            name: 'E'
          },
          19: {
            name: 'E'
          },
          20: {
            name: 'E'
          },
          21: {
            name: 'E'
          },
          22: {
            name: 'E'
          },
          23: {
            name: 'E'
          },
          24: {
            name: 'E'
          },
          25: {
            name: 'E'
          },
          26: {
            name: 'E'
          },
          27: {
            name: 'E'
          },
          28: {
            name: 'E'
          },
          29: {
            name: 'E'
          },
          30: {
            name: 'F'
          },
          41: {
            name: 'F'
          },
          42: {
            name: 'G'
          },
          43: {
            name: 'G'
          },
          44: {
            name: 'G'
          },
          45: {
            name: 'H'
          },
          46: {
            name: 'H'
          },
          47: {
            name: 'I'
          },
          48: {
            name: 'I'
          },
          49: {
            name: 'I'
          },
          50: {
            name: 'I'
          },
          51: {
            name: 'I'
          },
          52: {
            name: 'I'
          },
          53: {
            name: 'I'
          },
          54: {
            name: 'I'
          },
          55: {
            name: 'I'
          },
          56: {
            name: 'J'
          },
          57: {
            name: 'K'
          },
          58: {
            name: 'L'
          },
          59: {
            name: 'L'
          },
          60: {
            name: 'L'
          },
          61: {
            name: 'L'
          },
          62: {
            name: 'M'
          },
          63: {
            name: 'M'
          },
          64: {
            name: 'N'
          },
          65: {
            name: 'N'
          },
          66: {
            name: 'N'
          },
          67: {
            name: 'N'
          },
          68: {
            name: 'N'
          },
          69: {
            name: 'N'
          },
          70: {
            name: 'O'
          },
          71: {
            name: 'O'
          },
          72: {
            name: 'O'
          },
          73: {
            name: 'O'
          },
          74: {
            name: 'O'
          },
          75: {
            name: 'O'
          },
          76: {
            name: 'O'
          },
          77: {
            name: 'O'
          },
          78: {
            name: 'P'
          },
          79: {
            name: 'P'
          },
          80: {
            name: 'Q'
          },
          81: {
            name: 'R'
          },
          82: {
            name: 'R'
          },
          83: {
            name: 'R'
          },
          84: {
            name: 'R'
          },
          85: {
            name: 'R'
          },
          86: {
            name: 'R'
          },
          87: {
            name: 'S'
          },
          88: {
            name: 'S'
          },
          89: {
            name: 'S'
          },
          90: {
            name: 'S'
          },
          91: {
            name: 'T'
          },
          92: {
            name: 'T'
          },
          93: {
            name: 'T'
          },
          94: {
            name: 'T'
          },
          95: {
            name: 'T'
          },
          96: {
            name: 'T'
          },
          97: {
            name: 'U'
          },
          98: {
            name: 'U'
          },
          99: {
            name: 'U'
          },
          100: {
            name: 'U'
          },
          101: {
            name: 'V'
          },
          102: {
            name: 'V'
          },
          103: {
            name: 'W'
          },
          104: {
            name: 'W'
          },
          105: {
            name: 'X'
          },
          106: {
            name: 'U'
          },
          107: {
            name: 'Y'
          },
          108: {
            name: 'Y'
          },
          109: {
            name: 'Z'
          }
        };
      }
      if (dictionary === 'fise' || dictionary === 'tagalog') {
        return {
          1: {
            name: 'A'
          },
          2: {
            name: 'A'
          },
          3: {
            name: 'A'
          },
          4: {
            name: 'A'
          },
          5: {
            name: 'A'
          },
          6: {
            name: 'A'
          },
          7: {
            name: 'A'
          },
          8: {
            name: 'A'
          },
          9: {
            name: 'A'
          },
          10: {
            name: 'A'
          },
          11: {
            name: 'A'
          },
          12: {
            name: 'A'
          },
          13: {
            name: 'B'
          },
          14: {
            name: 'B'
          },
          15: {
            name: 'C'
          },
          16: {
            name: 'C'
          },
          17: {
            name: 'C'
          },
          18: {
            name: 'C'
          },
          19: {
            name: 'C'
          },
          20: {
            name: 'D'
          },
          21: {
            name: 'D'
          },
          22: {
            name: 'D'
          },
          23: {
            name: 'D'
          },
          24: {
            name: 'D'
          },
          25: {
            name: 'E'
          },
          26: {
            name: 'E'
          },
          27: {
            name: 'E'
          },
          28: {
            name: 'E'
          },
          29: {
            name: 'E'
          },
          30: {
            name: 'E'
          },
          31: {
            name: 'E'
          },
          32: {
            name: 'E'
          },
          33: {
            name: 'E'
          },
          34: {
            name: 'E'
          },
          35: {
            name: 'E'
          },
          36: {
            name: 'E'
          },
          37: {
            name: 'E'
          },
          38: {
            name: 'F'
          },
          39: {
            name: 'G'
          },
          40: {
            name: 'G'
          },
          41: {
            name: 'H'
          },
          42: {
            name: 'H'
          },
          43: {
            name: 'H'
          },
          44: {
            name: 'I'
          },
          45: {
            name: 'I'
          },
          46: {
            name: 'I'
          },
          47: {
            name: 'I'
          },
          48: {
            name: 'I'
          },
          49: {
            name: 'I'
          },
          50: {
            name: 'J'
          },
          51: {
            name: 'L'
          },
          52: {
            name: 'L'
          },
          53: {
            name: 'L'
          },
          54: {
            name: 'L'
          },
          55: {
            name: 'L'
          },
          56: {
            name: 'L'
          },
          57: {
            name: 'M'
          },
          58: {
            name: 'M'
          },
          59: {
            name: 'N'
          },
          60: {
            name: 'N'
          },
          61: {
            name: 'N'
          },
          62: {
            name: 'N'
          },
          63: {
            name: 'N'
          },
          64: {
            name: 'Ñ'
          },
          65: {
            name: 'Ñ'
          },
          66: {
            name: 'O'
          },
          67: {
            name: 'O'
          },
          68: {
            name: 'O'
          },
          69: {
            name: 'O'
          },
          70: {
            name: 'O'
          },
          71: {
            name: 'O'
          },
          72: {
            name: 'O'
          },
          73: {
            name: 'O'
          },
          74: {
            name: 'O'
          },
          75: {
            name: 'O'
          },
          76: {
            name: 'P'
          },
          77: {
            name: 'P'
          },
          78: {
            name: 'Q'
          },
          79: {
            name: 'R'
          },
          80: {
            name: 'R'
          },
          81: {
            name: 'R'
          },
          82: {
            name: 'R'
          },
          83: {
            name: 'R'
          },
          84: {
            name: 'R'
          },
          85: {
            name: 'R'
          },
          86: {
            name: 'S'
          },
          87: {
            name: 'S'
          },
          88: {
            name: 'S'
          },
          89: {
            name: 'S'
          },
          90: {
            name: 'S'
          },
          91: {
            name: 'S'
          },
          92: {
            name: 'S'
          },
          93: {
            name: 'T'
          },
          94: {
            name: 'T'
          },
          95: {
            name: 'T'
          },
          96: {
            name: 'T'
          },
          97: {
            name: 'U'
          },
          98: {
            name: 'U'
          },
          99: {
            name: 'U'
          },
          100: {
            name: 'U'
          },
          101: {
            name: 'U'
          },
          102: {
            name: 'V'
          },
          103: {
            name: 'X'
          },
          104: {
            name: 'Y'
          },
          105: {
            name: 'Z'
          }
        };
      }
      if (dictionary === 'test') {
        return {
          1: {
            name: 'A'
          },
          2: {
            name: 'A'
          },
          3: {
            name: 'A'
          },
          4: {
            name: 'A'
          },
          5: {
            name: 'A'
          },
          6: {
            name: 'A'
          },
          7: {
            name: 'A'
          },
          8: {
            name: 'A'
          },
          9: {
            name: 'A'
          },
          10: {
            name: 'C'
          },
          11: {
            name: 'C'
          },
          12: {
            name: 'C'
          },
          13: {
            name: 'C'
          },
          14: {
            name: 'T'
          },
          15: {
            name: 'T'
          },
          16: {
            name: 'T'
          },
          17: {
            name: 'T'
          },
          18: {
            name: 'T'
          },
          19: {
            name: 'T'
          },
          20: {
            name: 'T'
          }
        };
      }
      console.error('Undefined Letter Set');
      return {};
    }
  }, {
    key: "returnLetters",
    value: function returnLetters() {
      var dictionary = this.game.options.dictionary;
      if (dictionary === 'twl' || dictionary === 'sowpods') {
        return {
          A: {
            score: 1,
            count: 9
          },
          B: {
            score: 3,
            count: 2
          },
          C: {
            score: 2,
            count: 2
          },
          D: {
            score: 2,
            count: 4
          },
          E: {
            score: 1,
            count: 12
          },
          F: {
            score: 2,
            count: 2
          },
          G: {
            score: 2,
            count: 3
          },
          H: {
            score: 1,
            count: 2
          },
          I: {
            score: 1,
            count: 9
          },
          J: {
            score: 8,
            count: 1
          },
          K: {
            score: 4,
            count: 1
          },
          L: {
            score: 2,
            count: 4
          },
          M: {
            score: 2,
            count: 2
          },
          N: {
            score: 1,
            count: 6
          },
          O: {
            score: 1,
            count: 8
          },
          P: {
            score: 2,
            count: 2
          },
          Q: {
            score: 10,
            count: 1
          },
          R: {
            score: 1,
            count: 6
          },
          S: {
            score: 1,
            count: 4
          },
          T: {
            score: 1,
            count: 6
          },
          U: {
            score: 2,
            count: 5
          },
          V: {
            score: 3,
            count: 2
          },
          W: {
            score: 2,
            count: 2
          },
          X: {
            score: 8,
            count: 1
          },
          Y: {
            score: 2,
            count: 2
          },
          Z: {
            score: 10,
            count: 1
          }
        };
      }
      if (dictionary === 'fise' || dictionary === 'tagalog') {
        return {
          A: {
            score: 1,
            count: 12
          },
          B: {
            score: 2,
            count: 2
          },
          C: {
            score: 3,
            count: 5
          },
          D: {
            score: 2,
            count: 5
          },
          E: {
            score: 1,
            count: 13
          },
          F: {
            score: 4,
            count: 1
          },
          G: {
            score: 2,
            count: 2
          },
          H: {
            score: 4,
            count: 3
          },
          I: {
            score: 1,
            count: 6
          },
          J: {
            score: 8,
            count: 1
          },
          L: {
            score: 1,
            count: 6
          },
          M: {
            score: 3,
            count: 2
          },
          N: {
            score: 1,
            count: 5
          },
          Ñ: {
            score: 8,
            count: 2
          },
          O: {
            score: 1,
            count: 10
          },
          P: {
            score: 3,
            count: 2
          },
          Q: {
            score: 6,
            count: 1
          },
          R: {
            score: 2,
            count: 7
          },
          S: {
            score: 1,
            count: 7
          },
          T: {
            score: 1,
            count: 4
          },
          U: {
            score: 1,
            count: 5
          },
          V: {
            score: 4,
            count: 1
          },
          X: {
            score: 8,
            count: 1
          },
          Y: {
            score: 4,
            count: 1
          },
          Z: {
            score: 10,
            count: 1
          }
        };
      }
      if (dictionary === 'test') {
        return {
          A: {
            score: 1,
            count: 9
          },
          C: {
            score: 3,
            count: 4
          },
          T: {
            score: 2,
            count: 7
          }
        };
      }
      console.log('Error: No defined letter values');
      return {};
    }
  }, {
    key: "checkWord",
    value: function checkWord(word) {
      if (word.length == 0) {
        return false;
      }
      return this.wordlist.indexOf(word.toLowerCase()) >= 0;
    }
  }, {
    key: "returnBonus",
    value: function returnBonus(pos) {
      var bonus = '';
      if (pos == '1_1') {
        return '3L';
      }
      if (pos == '1_15') {
        return '3L';
      }
      if (pos == '3_8') {
        return '3L';
      }
      if (pos == '8_3') {
        return '3L';
      }
      if (pos == '8_13') {
        return '3L';
      }
      if (pos == '13_8') {
        return '3L';
      }
      if (pos == '15_1') {
        return '3L';
      }
      if (pos == '15_15') {
        return '3L';
      }
      if (pos == '2_2') {
        return '3W';
      }
      if (pos == '2_14') {
        return '3W';
      }
      if (pos == '8_8') {
        return '3W';
      }
      if (pos == '14_2') {
        return '3W';
      }
      if (pos == '14_14') {
        return '3W';
      }
      if (pos == '1_5') {
        return '2L';
      }
      if (pos == '1_11') {
        return '2L';
      }
      if (pos == '3_4') {
        return '2L';
      }
      if (pos == '3_12') {
        return '2L';
      }
      if (pos == '4_3') {
        return '2L';
      }
      if (pos == '4_13') {
        return '2L';
      }
      if (pos == '5_8') {
        return '2L';
      }
      if (pos == '5_1') {
        return '2L';
      }
      if (pos == '5_15') {
        return '2L';
      }
      if (pos == '8_5') {
        return '2L';
      }
      if (pos == '8_11') {
        return '2L';
      }
      if (pos == '11_1') {
        return '2L';
      }
      if (pos == '11_8') {
        return '2L';
      }
      if (pos == '11_15') {
        return '2L';
      }
      if (pos == '12_3') {
        return '2L';
      }
      if (pos == '12_13') {
        return '2L';
      }
      if (pos === '13_4') {
        return '2L';
      }
      if (pos === '13_12') {
        return '2L';
      }
      if (pos == '15_5') {
        return '2L';
      }
      if (pos == '15_11') {
        return '2L';
      }
      if (pos == '1_8') {
        return '2W';
      }
      if (pos == '4_6') {
        return '2W';
      }
      if (pos == '4_10') {
        return '2W';
      }
      if (pos == '6_4') {
        return '2W';
      }
      if (pos == '6_12') {
        return '2W';
      }
      if (pos == '8_1') {
        return '2W';
      }
      if (pos == '8_15') {
        return '2W';
      }
      if (pos == '10_4') {
        return '2W';
      }
      if (pos == '10_12') {
        return '2W';
      }
      if (pos == '12_6') {
        return '2W';
      }
      if (pos == '12_10') {
        return '2W';
      }
      if (pos == '15_8') {
        return '2W';
      }
      return bonus;
    }

    /*
     For scoring words, I use cartesian coordinate templating to make the coding easier
     (x,y) is represented as "y_x". A slot template fixes one of the dimensions with a constant
     to traverse the (main) axis of the word, or, alternately examine the cross axis of an 
     intersecting word.  "#" is used as a variable, to be replaced by "i" in the for loops.  
     */
  }, {
    key: "getWordScope",
    value: function getWordScope(head, slotPattern) {
      var boardslot;
      var wordStart = head;
      var wordEnd = head;
      for (var i = parseInt(head); i >= 1; i--) {
        boardslot = slotPattern.replace('#', i);
        if (this.game.board[boardslot].letter == '_') break;
        wordStart = i;
      }
      for (var _i10 = parseInt(head); _i10 <= 15; _i10++) {
        boardslot = slotPattern.replace('#', _i10);
        if (this.game.board[boardslot].letter == '_') break;
        wordEnd = _i10;
      }
      return {
        start: wordStart,
        end: wordEnd
      };
    }
  }, {
    key: "scoreWord",
    value: function scoreWord(wordStart, wordEnd, boardSlotTemplate) {
      var tilesUsed = 0;
      var word_bonus = 1;
      var thisword = '';
      var score = 0;
      var html = '';
      if (Object.keys(this.letters).length === 0) {
        this.letters = this.returnLetters();
      }
      for (var i = wordStart; i <= wordEnd; i++) {
        boardslot = boardSlotTemplate.replace('#', i);
        var letter_bonus = 1;
        if (this.game.board[boardslot] && this.game.board[boardslot].fresh == 1) {
          var tmpb = this.returnBonus(boardslot);
          switch (tmpb //Word_bonuses can be combined...maybe
          ) {
            case '3W':
              word_bonus = word_bonus * 3;
              break;
            case '2W':
              word_bonus = word_bonus * 2;
              break;
            case '3L':
              letter_bonus = 3;
              break;
            case '2L':
              letter_bonus = 2;
              break;
          }
          tilesUsed += 1;
        } else {
          touchesWord = 1;
        }
        var thisletter = this.game.board[boardslot].letter;
        //console.log(boardslot,thisletter);

        /*
           So we just save all the tiles in the play in a queue to animate after the fact
           Because it may be confusing if multiple words are being played at once and they
           all start flashing at once
           However, we do need a way to also queue the numbers to display on the screen 
           */
        this.tilesToHighlight.push("#".concat(boardslot, " .tile"));
        thisword += thisletter;
        score += this.letters[thisletter].score * letter_bonus;
        if (letter_bonus > 1) {
          html += " + ".concat(this.letters[thisletter].score, " x ").concat(letter_bonus);
        } else {
          html += ' + ' + this.letters[thisletter].score;
        }
      }
      if (!this.checkWord(thisword)) {
        salert(thisword + ' is not in the dictionary.');
        return -1;
      }

      /*Technically only care for the main word, but not worth adding code to avoid 
          doing a couple extra additions and a comparison
        */
      if (tilesUsed == 7) {
        score += 10;
        word_bonus += 1;
        html += ' +10(!)';
      }
      score *= word_bonus;
      html = html.substring(3);
      if (word_bonus > 1) {
        html = '(' + html + ') x ' + word_bonus;
      }
      //console.log("word:", thisword, "score:", score);
      return {
        word: thisword,
        score: score,
        math: html
      };
    }

    ////////////////
    // Score Word //
    // Returns -1 if not found in dictionary //
    ////////////////
  }, {
    key: "scorePlay",
    value: function scorePlay(word, player, orientation, x, y) {
      var boardslot;
      //Orientation-dependent metadata/variables
      var mainAxis = orientation == 'horizontal' ? x : y;
      var crossAxis = orientation == 'horizontal' ? y : x;
      var boardSlotTemplate = orientation == 'horizontal' ? crossAxis + '_#' : '#_' + crossAxis;

      //console.log(mainAxis, crossAxis, boardSlotTemplate);
      //
      // find the start and end of the word
      //
      var wordBoundaries = this.getWordScope(mainAxis, boardSlotTemplate);
      this.tilesToHighlight = []; // reset to empty array
      //Score main-axis word
      var results = this.scoreWord(wordBoundaries.start, wordBoundaries.end, boardSlotTemplate);
      if (results == -1) return -1;
      //console.log(orientation, wordBoundaries, results);
      var play = new Array(results);
      var totalscore = results.score;

      //For each letter in the main-axis word...

      for (var i = wordBoundaries.start; i <= wordBoundaries.end; i++) {
        boardslot = boardSlotTemplate.replace('#', i);

        //console.log(boardslot);
        if (this.game.board[boardslot] && this.game.board[boardslot].fresh == 1) {
          //...Is it newly placed...?
          var altTemplate = boardSlotTemplate.replace(crossAxis, '@').replace('#', i).replace('@', '#');
          //..and does it have a word along the cross axis
          var crossWord = this.getWordScope(crossAxis, altTemplate);
          if (crossWord.start != crossWord.end) {
            //Only score word if more than 1 letter
            //Make cross-axis variable
            //console.log(crossAxis, altTemplate, crossWord);
            results = this.scoreWord(crossWord.start, crossWord.end, altTemplate);
            if (results == -1) return -1;
            play.push(results);
            totalscore += results.score;
          }
        }
      }
      this.firstmove = 0; //We have an acceptable move, so game has commenced. Repeat assignment simpler than adding conditional
      //console.log(play);

      this.last_played_word[player - 1] = {
        word: play[0].word,
        totalscore: totalscore,
        play: play
      };
      //console.log(this.last_played_word);
      return totalscore;
    }
  }, {
    key: "expandWord",
    value: function expandWord(row, col, orientation) {
      var mainAxis = orientation == 'horizontal' ? col : row;
      var crossAxis = orientation == 'horizontal' ? row : col;
      var boardSlotTemplate = orientation == 'horizontal' ? crossAxis + '_#' : '#_' + crossAxis;
      var wordBoundaries = this.getWordScope(mainAxis, boardSlotTemplate);
      var fullword = '';
      for (var i = wordBoundaries.start; i <= wordBoundaries.end; i++) {
        boardslot = boardSlotTemplate.replace('#', i);
        fullword += this.game.board[boardslot].letter; //Reading letter
      }
      //console.log(`Found ${fullword} at row ${row}, col ${col} (${orientation})`, wordBoundaries);
      var newx, newy;
      if (orientation == 'horizontal') {
        newy = row;
        newx = wordBoundaries.start;
      } else {
        newy = wordBoundaries.start;
        newx = col;
      }
      //console.log(`${orientation}, new row: ${newy}, new col: ${newx}`);
      return {
        word: fullword,
        minx: newx,
        miny: newy
      };
    }

    //
    // Core Game Logic
    //
  }, {
    key: "handleGameLoop",
    value: function () {
      var _handleGameLoop = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var msg,
          wordblocks_self,
          qe,
          mv,
          x,
          idx,
          i,
          txSent,
          winners,
          _i11,
          player,
          tileCt,
          name,
          word,
          _player,
          _x2,
          y,
          orient,
          expanded,
          score,
          _player2,
          discardedTiles,
          _msg,
          _args6 = arguments;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              msg = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : null;
              wordblocks_self = this;
              if (!this.loadingDictionary) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2, 0);
            case 1:
              if (!(this.game.queue.length > 0)) {
                _context6.n = 13;
                break;
              }
              qe = this.game.queue.length - 1;
              mv = this.game.queue[qe].split('\t'); //
              // game over -- pick the winner
              //
              if (!(mv[0] === 'gameover')) {
                _context6.n = 9;
                break;
              }
              this.game.queue = [];
              x = 0;
              idx = -1; //Find Highest Score
              for (i = 0; i < this.game.score.length; i++) {
                if (this.game.score[i] > x) {
                  x = this.game.score[i];
                  idx = i;
                }
              }
              this.game.canProcess = true;
              if (!this.gameOverCallback) {
                _context6.n = 2;
                break;
              }
              console.log('Run game over callback!!!');
              this.gameOverCallback();
              return _context6.a(2, 0);
            case 2:
              txSent = null;
              if (!(idx < 0)) {
                _context6.n = 4;
                break;
              }
              _context6.n = 3;
              return this.sendGameOverTransaction([], 'no winners');
            case 3:
              txSent = _context6.v;
              _context6.n = 8;
              break;
            case 4:
              winners = [this.game.players[idx]]; //Check for ties -- will need to improve the logic for multi winners
              for (_i11 = 0; _i11 < this.game.score.length; _i11++) {
                if (_i11 != idx && this.game.score[_i11] == this.game.score[idx]) {
                  winners.push(this.game.players[_i11]);
                }
              }
              if (!(winners.length == this.game.players.length)) {
                _context6.n = 6;
                break;
              }
              _context6.n = 5;
              return this.sendGameOverTransaction(this.game.players, 'tie');
            case 5:
              txSent = _context6.v;
              _context6.n = 8;
              break;
            case 6:
              _context6.n = 7;
              return this.sendGameOverTransaction(winners, 'high score');
            case 7:
              txSent = _context6.v;
            case 8:
              // If async and I finish, but lose... won't get the official game over tx
              // until my friend reconnects..., so simulate!
              if (txSent) {
                this.receiveGameoverTransaction(0, txSent, 0, this.app);
              }
              return _context6.a(2, 0);
            case 9:
              if (mv[0] === 'report_tiles') {
                player = parseInt(mv[1]);
                tileCt = parseInt(mv[2]);
                this.game.queue.splice(this.game.queue.length - 1, 1);
                console.log(player, tileCt);
                name = player === this.game.player ? 'You are' : "".concat(this.game.playerNames[player - 1], " is");
                this.updateLog("".concat(name, " down to ").concat(tileCt, " tiles"));
              }

              //
              // place word player x y [horizontal/vertical]
              //
              if (!(mv[0] === 'place')) {
                _context6.n = 11;
                break;
              }
              word = mv[1];
              _player = mv[2];
              _x2 = mv[3];
              y = mv[4];
              orient = mv[5];
              expanded = mv[6];
              score = 0; //Set up next player's turn
              this.game.target = this.returnNextPlayer(_player);
              console.log('Update target: ', this.game.target);

              //Don't process placement until user is in game
              if (this.gameBrowserActive()) {
                _context6.n = 10;
                break;
              }
              if (this.game.player == this.game.target) {
                this.updateStatusWithTiles("YOUR GO: ".concat(this.defaultMsg));
                this.setPlayerActive();
                console.log('Trigger Playerturn: ', JSON.parse(JSON.stringify(this.game)));
              }
              return _context6.a(2, 0);
            case 10:
              this.game.queue.splice(this.game.queue.length - 1, 1);
              if (_player != this.game.player) {
                this.addWordToBoard(word, orient, _x2, y);
                //this.setBoard(word, orient, x, y);
                score = this.scorePlay(word, _player, orient, _x2, y);
                this.finalizeWord(word, orient, _x2, y);
                this.addScoreToPlayer(_player, score);
                this.game.words_played[parseInt(_player) - 1].push({
                  word: expanded,
                  score: score
                });
                this.updateLog("".concat(this.game.playerNames[_player - 1], " played ").concat(expanded, " for ").concat(score, " points"));
              } else {
                score = this.getLastMove(_player).score;
              }
              this.animatePlay();
            case 11:
              if (!(mv[0] === 'discard_tiles')) {
                _context6.n = 13;
                break;
              }
              _player2 = parseInt(mv[1]);
              discardedTiles = mv[2]; //string
              this.game.target = this.returnNextPlayer(_player2);
              console.log('Update target: ', this.game.target);
              if (this.gameBrowserActive()) {
                _context6.n = 12;
                break;
              }
              if (this.game.player == this.game.target) {
                this.updateStatusWithTiles("YOUR GO: ".concat(this.defaultMsg));
                this.setPlayerActive();
              }
              return _context6.a(2, 0);
            case 12:
              this.game.queue.splice(this.game.queue.length - 1, 1);
              _msg = discardedTiles.length > 0 ? 'discarded some tiles' : 'passed';
              if (_player2 !== this.game.player) {
                this.updateLog("".concat(this.game.playerNames[_player2 - 1], " ").concat(_msg, "."));
              } else {
                this.updateLog("You ".concat(_msg, "."));
              }

              //Code to keep the discard and redraws in the game log history
              wordblocks_self.last_played_word[_player2 - 1] = {
                word: discardedTiles,
                totalscore: 0
              };
              wordblocks_self.game.words_played[_player2 - 1].push({
                word: '---',
                score: 0
              });
            case 13:
              // Set UI here...
              if (this.game.queue.length == 0) {
                if (this.game.player == this.game.target) {
                  this.updateStatusWithTiles("YOUR GO: ".concat(this.defaultMsg));
                  this.setPlayerActive();
                  this.enableEvents();
                } else {
                  this.updateStatusWithTiles("".concat(this.game.playerNames[this.game.target - 1], "'s turn"));
                  this.startClock();
                }
                $('.score.active').removeClass('active');
                this.playerbox.setActive(this.game.target);
                $("#mobile_score_".concat(this.game.target)).addClass('active');

                // We add a save point here so closing the tab doesn't break the game
                console.log('Save Wordblocks game');
                this.saveGame(this.game.id);
              }
              return _context6.a(2, 1);
          }
        }, _callee6, this);
      }));
      function handleGameLoop() {
        return _handleGameLoop.apply(this, arguments);
      }
      return handleGameLoop;
    }()
  }, {
    key: "checkForEndGame",
    value: function checkForEndGame() {
      if (this.game.deck[0].hand.length == 0 && this.game.deck[0].crypt.length == 0) {
        return 1;
      }
      return 0;
    }
  }, {
    key: "addScoreToPlayer",
    value: function addScoreToPlayer(player, score) {
      if (!this.gameBrowserActive()) {
        return;
      }
      this.game.score[player - 1] = this.getPlayerScore(player) + score;
      this.refreshPlayerScore(player);
    }
  }, {
    key: "endTurn",
    value: function endTurn() {
      this.updateStatusWithTiles('Waiting for information from peers....');
      _superPropGet(Wordblocks, "endTurn", this, 3)([]);
    }
  }, {
    key: "returnAdvancedOptions",
    value: function returnAdvancedOptions() {
      return WordblocksGameOptionsTemplate(this.app, this);
    }
  }, {
    key: "animatePlay",
    value: function () {
      var _animatePlay = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _iterator4, _step4, _tile, _t;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _iterator4 = _createForOfIteratorHelper(this.tilesToHighlight);
              _context7.p = 1;
              _iterator4.s();
            case 2:
              if ((_step4 = _iterator4.n()).done) {
                _context7.n = 4;
                break;
              }
              _tile = _step4.value;
              $(_tile).css('color', 'white').css('background', 'black').delay(250).queue(function () {
                $(this).css('color', '').css('background', '').dequeue();
              });
              _context7.n = 3;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 250);
              });
            case 3:
              _context7.n = 2;
              break;
            case 4:
              _context7.n = 6;
              break;
            case 5:
              _context7.p = 5;
              _t = _context7.v;
              _iterator4.e(_t);
            case 6:
              _context7.p = 6;
              _iterator4.f();
              return _context7.f(6);
            case 7:
              return _context7.a(2);
          }
        }, _callee7, this, [[1, 5, 6, 7]]);
      }));
      function animatePlay() {
        return _animatePlay.apply(this, arguments);
      }
      return animatePlay;
    }()
  }, {
    key: "refreshPlayerScore",
    value: function refreshPlayerScore(player) {
      var score = this.getPlayerScore(player);
      if (document.getElementById("score_".concat(player))) {
        document.getElementById("score_".concat(player)).innerHTML = score;
      }
      if (document.getElementById("mobile_score_".concat(player))) {
        document.getElementById("mobile_score_".concat(player)).innerHTML = "<img class=\"player-identicon\" src=\"".concat(this.app.keychain.returnIdenticon(this.game.players[player - 1]), "\"><span>: ").concat(score, "</span>");
      }
    }
  }, {
    key: "displayRemainingTiles",
    value: function displayRemainingTiles() {
      var html = "<div class=\"remaining_tiles\">";
      for (var letter in this.letters) {
        var printed = false;
        for (var j = 0; j < this.letters[letter].count; j++) {
          printed = true;
          html += this.returnTileHTML(letter);
        }
        if (printed) {
          html += "<div class=\"gap\"></div>";
        }
      }
      html += '</div>';
      this.overlay.show(html);
    }
  }]);
}(GameTemplate);
module.exports = Wordblocks;